import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { useParams } from 'react-router-dom'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import { OSSURL } from '../constant'
import NullData from './nullData'

const ListHead = styled.div`
  height: 40px;
  background-image: linear-gradient(
    90deg,
    rgba(6, 16, 41, 0) 0%,
    #0061b2 44%,
    rgba(6, 16, 41, 0) 100%
  );
  color: #3efaff;
  ${tw`w-full flex items-center justify-between px-4 font-bold mb-2`};
`
const ListBody = styled.div`
  background: ${(props) => {
    return props.i % 2 === 0
      ? `url(${OSSURL}/list_bg_odd.png) no-repeat`
      : `url(${OSSURL}/list_bg_even.png) no-repeat`
  }};
  background-size: 100% 100%;
  height: 36px;
  ${tw`w-full flex items-center justify-between px-4 text-xs`}
  .percent {
    color: #ffde0d;
  }
`

const List = function ({ data, customDsl, filter }) {
  const { appId } = useParams()
  const [itemData, setItemData] = useState({})

  useEffect(() => {
    console.log('list--filter', filter, data.filterSlug)
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        const result = res
        if (filter && data.filterSlug) {
          result.data = res.data.filter((r) => {
            return r[data.filterSlug] === filter
          })
        }
        setItemData(result)
      })
  }, [customDsl, data, filter])

  return (
    <div className="w-full" style={{ maxHeight: '200px' }}>
      {Object.keys(itemData).length === 0 && <NullData />}
      {Object.keys(itemData).length !== 0 && (
        <>
          <ListHead>
            {itemData.titleOrder.map((th) => {
              return (
                <div key={th} className="w-1/3">
                  {th}
                </div>
              )
            })}
          </ListHead>
          <div className="flex flex-col w-full gap-2 overflow-y-auto">
            {itemData.data.map((tb, k) => {
              return (
                <ListBody i={k + 1}>
                  {Object.keys(tb).map((t, i) => {
                    return (
                      <div className="w-1/3" style={{ fontSize: '14px' }}>
                        {tb[itemData.titleOrder[i]]}
                      </div>
                    )
                  })}
                </ListBody>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default List
